module.exports = __webpack_public_path__ + "img/12_38.1a0aaaf5.png";